"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import styles from './Icon.module.scss.mjs';
import clsx from 'clsx';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { cloneElement } from '../../lib/react/cloneElement.mjs';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';

const Icon = flowComponent("Icon", (props) => {
  const {
    className,
    "aria-label": ariaLabel,
    children,
    size = "m",
    status,
    ref: ignoredRef,
    ...svgAttributes
  } = props;
  const iconProps = {
    ...svgAttributes,
    focusable: "false",
    role: "img",
    "aria-hidden": !ariaLabel,
    "aria-label": ariaLabel,
    className: clsx(
      styles.icon,
      className,
      styles[`size-${size}`],
      status && styles[status]
    )
  };
  const iconElement = React.Children.toArray(children)[0];
  if (!React.isValidElement(iconElement)) {
    throw new Error(
      `Expected children of Icon component to be a valid React element (got ${String(
        children
      )})`
    );
  }
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: cloneElement(iconElement, iconProps) });
});

export { Icon, Icon as default };
//# sourceMappingURL=Icon.mjs.map
